export default [
    '08:30-10:00',
    '10:10-11:40',
    '12:10-13:40',
    '13:50-15:20',
    '15:50-17:20',
    '17:30-19:00',
    '19:10-20:40',
];